export default __webpack_public_path__ + "static/media/SeptDom2024.88c605b9.jpg";